import { s as setMainAlertContent, a as setMainAlertVisibility } from "../../../../../chunks/db.js";
import { json } from "@sveltejs/kit";
const POST = async ({ request, cookies }) => {
  const data = await request.json();
  await setMainAlertContent(data.content);
  await setMainAlertVisibility(data.visible);
  return json({ success: true });
};
export {
  POST
};
//# sourceMappingURL=_server.ts.js.map
